<div xpoDynamicMenu data-cy="grid-toolbar-actions" (hiddenBtnEvent)="updateButtonsVisibility($event)">
  <ng-content></ng-content>
  <xpo-grid-toolbar-dynamic-more #dynamicMoreMenu [dynButtons]="buttons" xpoDynamicMenuBlock data-cy="grid-toolbar-actions-dynamic">
    <ng-content select="xpo-grid-toolbar-actions-group-more"></ng-content>
  </xpo-grid-toolbar-dynamic-more>
</div>